import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Addons = ({goToNextTab}) => {
  const [sortOption, setSortOption] = useState('date-desc');
  const [filterSpam, setFilterSpam] = useState(true);
  const [forwarding, setForwarding] = useState(false);
  const [forwardEmail, setForwardEmail] = useState('');
  const [autoReply, setAutoReply] = useState(false);
  const [replyMessage, setReplyMessage] = useState('');
const nav = useNavigate()


  const handleSubmit = (e) => {
    e.preventDefault();
  goToNextTab()
  };

  return (
  
    <div className="min-h-screen bg-gray-100 flex  justify-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Mail Processing Options</h1>
        
        <div className="space-y-6">
          {/* Sorting Options */}
          <div>
            <h2 className="text-lg font-semibold text-gray-700">Option 1</h2>
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="mt-2 w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="date-desc">Option of Option 1</option>
            </select>
          </div>

          {/* Spam Filter */}
          <div>
            <h2 className="text-lg font-semibold text-gray-700">Option 2</h2>
            <label className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={filterSpam}
                onChange={(e) => setFilterSpam(e.target.checked)}
                className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-gray-600">Enable Option 2</span>
            </label>
          </div>

          {/* Email Forwarding */}
          <div>
            <h2 className="text-lg font-semibold text-gray-700">Option 3</h2>
            <label className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={forwarding}
                onChange={(e) => setForwarding(e.target.checked)}
                className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-gray-600">Enable Option 3</span>
            </label>
            {forwarding && (
              <input
                type="email"
                value={forwardEmail}
                onChange={(e) => setForwardEmail(e.target.value)}
                placeholder="Enter Option 3 Value"
                className="mt-2 w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            )}
          </div>

          {/* Auto-Reply */}
          <div>
            <h2 className="text-lg font-semibold text-gray-700">Option 4</h2>
            <label className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={autoReply}
                onChange={(e) => setAutoReply(e.target.checked)}
                className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-gray-600">Enable Option 4</span>
            </label>
            {autoReply && (
              <textarea
                value={replyMessage}
                onChange={(e) => setReplyMessage(e.target.value)}
                placeholder="Enter Presort Directions"
                className="mt-2 w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
              />
            )}
          </div>

          {/* Save Button */}
          <div>
            <button
             type="submit"
              className="w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition duration-200"
              onClick={handleSubmit}
            >
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
   
  );
};

export default Addons;

// import React from 'react'
// import { useJobContext } from '../../context/JobContext'

// const Addons = () => {
//      const {sendjob} = useJobContext()
//   return (
//     <div>Addons
//         <br />  <button
                      
//                         type="button" className="bg-blue-500 text-white px-6 py-1 rounded"
//                       >
//                         Next ->
//                       </button>
//                       <br />
//                        <br />
//                        <button
//                       onClick={() => sendjob()}
//                         type="button" className="bg-blue-500 text-white px-6 py-1 rounded"
//                       >
//                         Send Job
//                       </button>
//     </div>
//   )
// }

// export default Addons